import { render } from "./addRIIForm.vue?vue&type=template&id=60ec11c0&scoped=true"
import script from "./addRIIForm.vue?vue&type=script&lang=js"
export * from "./addRIIForm.vue?vue&type=script&lang=js"

import "./addRIIForm.vue?vue&type=style&index=0&id=60ec11c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ec11c0"]])

export default __exports__